(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kcl-measurement"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const root = document.querySelector('[data-kos-measurement]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    const pageKinds = new Set(['home', 'estimate', 'contact', 'residential', 'commercial', 'permanent', 'tree_wrapping', 'services', 'service_areas', 'local_area', 'careers', 'design_studio', 'editorial', 'our_work', 'color_selections', 'our_story', 'hoa', 'church', 'weddings', 'removal_storage', 'other']);
    const pageKind = pageKinds.has(root.dataset.pageKind) ? root.dataset.pageKind : 'other';
    const directoryOrigin = 'https://directory.christmascontractor.com';
    const state = value => { root.dataset.state = value; };
    const isProduction = () => root.dataset.editor !== 'true' && !window.Shopify?.designMode && window.Shopify?.theme?.role === 'main';
    if (!isProduction()) { state('preview'); return; }

    const pendingKey = 'kingdom_os:contact_pending:v1';
    const startedForms = new WeakSet();
    const attemptedForms = new WeakSet();
    const clickedLinks = new WeakMap();
    let contactConfirmed = false;
    let pendingWritten = false;
    let estimateStarted = false;
    let estimateAttempted = false;
    let estimateConfirmed = false;
    let studioViewed = false;
    let studioAttempted = false;
    let studioConfirmed = false;
    let pageViewed = false;
    let referralSource;
    const referralKey = 'kcl:referral-source:v1';
    const aiSources = new Map([
      ['chatgpt.com', 'chatgpt'], ['chat.openai.com', 'chatgpt'],
      ['perplexity.ai', 'perplexity'], ['gemini.google.com', 'gemini'],
      ['copilot.microsoft.com', 'copilot'], ['claude.ai', 'claude']
    ]);
    const sourceNames = new Set([...aiSources.values(), 'other_or_unknown']);
    const sourceForHost = host => {
      for (const [domain, source] of aiSources) {
        if (host === domain || host.endsWith('.' + domain)) return source;
      }
      return null;
    };
    // Called only after analytics consent. Store a closed source name, never a URL,
    // search prompt, form field or customer identifier. Google Search is not inferred to be AI.
    const getReferralSource = () => {
      if (referralSource) return referralSource;
      let source = null;
      let internal = false;
      try {
        const current = new URL(window.location.href);
        const tagged = (current.searchParams.get('utm_source') || '').toLowerCase();
        source = aiSources.get(tagged) || (sourceNames.has(tagged) ? tagged : null);
        if (document.referrer) {
          const referrer = new URL(document.referrer);
          internal = referrer.origin === current.origin;
          source = source || sourceForHost(referrer.hostname);
        }
      } catch {}
      try {
        const previous = internal ? window.sessionStorage.getItem(referralKey) : null;
        source = source || (sourceNames.has(previous) ? previous : 'other_or_unknown');
        window.sessionStorage.setItem(referralKey, source);
      } catch {}
      referralSource = source || 'other_or_unknown';
      return referralSource;
    };

    const ready = () => {
      if (!isProduction()) { state('preview'); return false; }
      try {
        if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') {
          state('consent_unavailable'); return false;
        }
        if (window.Shopify.customerPrivacy.analyticsProcessingAllowed() !== true) {
          state('consent_denied'); return false;
        }
        if (typeof window.Shopify?.analytics?.publish !== 'function') {
          state('publisher_unavailable'); return false;
        }
        state('ready');
        return true;
      } catch { state('consent_unavailable'); return false; }
    };

    const publish = (name, data) => {
      if (!ready()) return false;
      try {
        const result = window.Shopify.analytics.publish('kingdom_os:' + name, {
          schema_version: 1,
          page_kind: pageKind,
          referral_source: getReferralSource(),
          ...data
        });
        if (result === false) { state('publisher_unavailable'); return false; }
        if (result && typeof result.catch === 'function') result.catch(() => state('publisher_error'));
        return true;
      } catch { state('publisher_error'); return false; }
    };

    const surfaceFor = element => {
      if (element.closest('[data-kpro-header]')) return 'header';
      if (element.closest('[data-kpro-footer]')) return 'footer';
      if (element.closest('.kos-hero, .kos-service-hero')) return 'hero';
      if (element.closest('[data-kos-directory-estimate-shell]')) return 'estimate_embed';
      if (element.closest('.kos-live-studio')) return 'design_studio';
      if (element.closest('.kos-contact')) return 'contact';
      if (element.closest('.kos-faq')) return 'faq';
      if (element.closest('.kos-final, .kos-service-cta')) return 'final_cta';
      return 'content';
    };

    const actionFor = link => {
      try {
        const destination = new URL(link.getAttribute('href'), window.location.origin + window.location.pathname);
        if (destination.protocol === 'tel:') return 'phone';
        if (destination.protocol === 'mailto:') return 'email';
        if (destination.protocol !== 'https:') return null;
        const path = destination.pathname.replace(/\/+$/, '');
        if (destination.origin === directoryOrigin && path.startsWith('/estimate/embed/')) return 'estimate';
        if (destination.origin === directoryOrigin && /^\/design-studio\/embed\/[^/]+$/.test(path)) return 'design_studio';
        if (destination.origin !== window.location.origin) return null;
        if (path === '/pages/estimate') return 'estimate';
        if (path === '/pages/contact') return 'contact';
        if (path === '/pages/design-studio') return 'design_studio';
        return null;
      } catch { return null; }
    };

    document.addEventListener('click', event => {
      if (!event.isTrusted || event.defaultPrevented || !ready()) return;
      const link = event.target?.closest?.('a[href]');
      if (!link || link.closest('form')) return;
      const action = actionFor(link);
      if (!action) return;
      const now = Date.now();
      if (clickedLinks.has(link) && now - clickedLinks.get(link) < 1000) return;
      if (publish('service_cta', { action, surface: surfaceFor(link) })) clickedLinks.set(link, now);
    });

    const formFor = target => {
      const form = target?.closest?.('form');
      if (!form) return null;
      if (form.matches('.kos-contact__form')) return { form, type: 'contact' };
      return null;
    };

    const startForm = event => {
      if (!event.isTrusted || !ready()) return;
      if (!event.target?.matches?.('input:not([type="hidden"]):not([type="submit"]):not([type="button"]), textarea, select')) return;
      const match = formFor(event.target);
      if (!match || startedForms.has(match.form)) return;
      if (publish('form_start', { form_type: match.type })) startedForms.add(match.form);
    };
    document.addEventListener('input', startForm);
    document.addEventListener('change', startForm);

    document.addEventListener('submit', event => {
      if (!event.isTrusted || event.defaultPrevented || !ready()) return;
      const match = formFor(event.target);
      if (!match || match.form.matches(':invalid') || attemptedForms.has(match.form)) return;
      if (!publish('form_submit_attempt', { form_type: match.type })) return;
      attemptedForms.add(match.form);
      if (match.type === 'contact') {
        try { window.sessionStorage.setItem(pendingKey, String(Date.now())); pendingWritten = true; } catch {}
      }
    }, true);

    // The Kingdom OS form is cross-origin by design. Its iframe bridge sends only these three
    // closed event names plus the non-PII custody state; customer field values never cross.
    window.addEventListener('kingdom-os:estimate-event', event => {
      if (!ready()) return;
      const detail = event?.detail;
      if (!detail || typeof detail !== 'object') return;
      if (detail.event === 'form_start' && !estimateStarted) {
        estimateStarted = publish('form_start', { form_type: 'estimate' });
      } else if (detail.event === 'submit_attempt' && !estimateAttempted) {
        estimateAttempted = publish('form_submit_attempt', { form_type: 'estimate' });
      } else if (detail.event === 'submitted' && !estimateConfirmed) {
        const custody = detail.custody;
        if (custody !== 'organization_routed' && custody !== 'platform_pending_claim') return;
        estimateConfirmed = publish('estimate_confirmation', { form_type: 'estimate', custody });
      }
    });

    window.addEventListener('kingdom-os:studio-event', event => {
      if (!ready()) return;
      const detail = event?.detail;
      if (!detail || typeof detail !== 'object') return;
      if (detail.event === 'submit_attempt' && !studioAttempted) {
        studioAttempted = publish('form_submit_attempt', { form_type: 'design_studio' });
      } else if (detail.event === 'submitted' && !studioConfirmed) {
        if (typeof detail.designAttached !== 'boolean' || typeof detail.renderedImageAttached !== 'boolean') return;
        if (detail.renderedImageAttached && !detail.designAttached) return;
        studioConfirmed = publish('studio_confirmation', {
          form_type: 'design_studio',
          design_attached: detail.designAttached,
          rendered_image_attached: detail.renderedImageAttached
        });
      }
    });

    const checkContact = () => {
      if (contactConfirmed || !ready() || !document.querySelector('.kos-contact__notice--success[data-kos-contact-result="success"]')) return;
      let submittedAt;
      try {
        submittedAt = Number(window.sessionStorage.getItem(pendingKey));
        window.sessionStorage.removeItem(pendingKey);
      } catch { return; }
      const age = Date.now() - submittedAt;
      if (!submittedAt || !Number.isFinite(submittedAt) || age < 0 || age > 30 * 60 * 1000) return;
      contactConfirmed = publish('contact_confirmation', { form_type: 'contact' });
    };

    const checkCurrentState = () => {
      if (!ready()) {
        if (root.dataset.state === 'consent_denied') {
          referralSource = undefined;
          try { window.sessionStorage.removeItem(referralKey); } catch {}
        }
        if (pendingWritten) {
          try { window.sessionStorage.removeItem(pendingKey); } catch {}
          pendingWritten = false;
        }
        return;
      }
      if (!pageViewed) pageViewed = publish('service_page_view', {});
      checkContact();
      if (pageKind === 'design_studio' && !studioViewed) {
        studioViewed = publish('studio_view', { form_type: 'design_studio' });
      }
    };
    document.addEventListener('visitorConsentCollected', checkCurrentState);
    window.addEventListener('pageshow', checkCurrentState);
    if (!window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (error) { state('consent_unavailable'); return; }
          checkCurrentState();
        });
      } catch { state('consent_unavailable'); }
    }
    checkCurrentState();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
